// extracted by mini-css-extract-plugin
module.exports = {"card":"vkiGzL","menuContainerButton":"_3MaIIj"};